import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileScrollService {
  private isSideNavOpen = new BehaviorSubject(false);
  private isFilterOpen = new BehaviorSubject(false);
  private isFilterOptionsOpen = new BehaviorSubject(false);
  private isSuggestionOpen = new BehaviorSubject(false);
  private isScrollHidden = new BehaviorSubject(false);

  isSideNavOpen$ = this.isSideNavOpen.asObservable();
  isFilterOpen$ = this.isFilterOpen.asObservable();
  isFilterOptionsOpen$ = this.isFilterOptionsOpen.asObservable();
  isSuggestionOpen$ = this.isSuggestionOpen.asObservable();
  isScrollHidden$ = this.isScrollHidden.asObservable();

  toggleSideNav(open: boolean) {
    this.isSideNavOpen.next(open);
    this.toggleScrollHidden();
  }

  toggleFilter(open: boolean) {
    this.isFilterOpen.next(open);
    this.toggleScrollHidden();
  }

  toggleFilterOptions(open: boolean) {
    this.isFilterOptionsOpen.next(open);
  }

  toggleSuggestion(open: boolean) {
    this.isSuggestionOpen.next(open);
    this.toggleScrollHidden();
  }

  toggleScrollHidden() {
    this.isScrollHidden.next(
      this.isFilterOpen.value ||
        this.isSideNavOpen.value ||
        this.isSuggestionOpen.value
    );
  }
}
